class PdpProductDescription extends HTMLElement {
  connectedCallback() {
    this.contentWrap = this.querySelector(".pdp-product-description__content-wrap");
    this.content = this.querySelector(".pdp-product-description__content");
    this.toggleButton = this.querySelector(".pdp-product-description__toggle");
    this.toggleLabel = this.querySelector(".pdp-product-description__toggle-label");
    if (!this.contentWrap || !this.content || !this.toggleButton) return;

    this.onToggle = () => this.setExpanded(!this.classList.contains("is-expanded"));
    this.onResize = () => this.updateCollapsibleState();
    this.toggleButton.addEventListener("click", this.onToggle);
    window.addEventListener("resize", this.onResize, { passive: true });
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.content);
    }
    this.updateCollapsibleState();
    document.fonts?.ready.then(() => { if (this.isConnected) this.updateCollapsibleState(); });
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.toggleButton?.removeEventListener("click", this.onToggle);
    window.removeEventListener("resize", this.onResize);
  }

  updateCollapsibleState() {
    if (!this.content.clientWidth) return;
    const text = this.content.querySelector("p, li") || this.content;
    const styles = getComputedStyle(text);
    const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.5;
    this.style.setProperty("--pdp-description-collapsed-height", `${lineHeight * 3}px`);
    const collapsible = this.content.scrollHeight > lineHeight * 3 + 1;
    this.classList.toggle("is-collapsible", collapsible);
    if (!collapsible) this.setExpanded(false);
  }

  setExpanded(expanded) {
    this.classList.toggle("is-expanded", expanded);
    this.toggleButton.setAttribute("aria-expanded", String(expanded));
    this.toggleLabel.textContent = expanded
      ? this.toggleButton.dataset.labelLess || ""
      : this.toggleButton.dataset.labelMore || "";
  }
}

if (!customElements.get("pdp-product-description")) {
  customElements.define("pdp-product-description", PdpProductDescription);
}
